import { useState, useEffect } from 'react';
import 'stream-chat-react';
import '@planningcenter/datetime-fmt';
import '../../../../_virtual/moment.js';
import '../../../chat_context.js';
import { useChatApi } from '../../../hooks/use_chat_api.js';
import '@planningcenter/url';
import '@planningcenter/jolt-client';
import 'stream-chat';

const useTeamOptions = (values, isActive) => {
    const [options, setOptions] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const api = useChatApi();
    useEffect(() => {
        if (!isActive)
            return;
        setLoading(true);
        api.services
            .get("chat", { fields: { Chat: "teams" } })
            .then(({ teams }) => setOptions(teams))
            .catch(() => setIsError(true))
            .finally(() => setLoading(false));
    }, [isActive]);
    const [selected, unselected] = options.reduce((acc, option) => {
        const isSelected = values.teams.some(({ team_id }) => team_id === option.value.team_id);
        acc[isSelected ? 0 : 1].push(option);
        return acc;
    }, [[], []]);
    return [selected, unselected, isLoading, isError];
};

export { useTeamOptions };
//# sourceMappingURL=use_team_options.js.map
